import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "toolbar", "count", "form", "bulkActionInput"];

  connect() {
    this.updateToolbar();
  }

  toggle() {
    this.updateToolbar();
  }

  toggleAll(event) {
    this.checkboxTargets.forEach((cb) => {
      cb.checked = event.target.checked;
    });
    this.updateToolbar();
  }

  updateToolbar() {
    const selected = this.checkboxTargets.filter((cb) => cb.checked);
    const count = selected.length;
    this.countTargets.forEach((el) => {
      el.textContent = count;
    });
    this.toolbarTargets.forEach((el) => {
      el.classList.toggle("hidden", count === 0);
    });
  }

  bulkAction(event) {
    const actionName = event.params.action;
    const ids = this.checkboxTargets.filter((cb) => cb.checked).map((cb) => cb.value);
    if (ids.length === 0) return;

    const form = this.formTarget;
    this.bulkActionInputTarget.value = actionName;

    form.querySelectorAll('[name="ids[]"]').forEach((el) => el.remove());
    ids.forEach((id) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "ids[]";
      input.value = id;
      form.appendChild(input);
    });

    form.requestSubmit();
  }
}
